;
var sprite = require("/tmp/build_28b142ae/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Search_928856be57d1e56d5e0781604b8a9914\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path d=\"M92.179,89.062L75.091,71.976c5.155-5.904,8.29-13.611,8.29-22.032c0-18.487-15.082-33.571-33.571-33.571\r\n\t\tc-18.487,0-33.57,15.084-33.57,33.571s15.083,33.57,33.57,33.57c8.539,0,16.344-3.222,22.28-8.505l17.071,17.07L92.179,89.062z\r\n\t\t M20.521,49.943c0-16.153,13.136-29.289,29.289-29.289s29.289,13.136,29.289,29.289c0,16.151-13.136,29.289-29.289,29.289\r\n\t\tS20.521,66.095,20.521,49.943z\"/> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Search_928856be57d1e56d5e0781604b8a9914");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Search.svg
// module id = 1415
// module chunks = 0